import { EnvironmentProviders, makeEnvironmentProviders, provideEnvironmentInitializer } from '@angular/core';

import { MOCK_DB } from './mock-api.interceptor';

// -----------------------------------------------------------------------------------------------------
// @ PROVIDERS
// -----------------------------------------------------------------------------------------------------

/**
 * Installs the mock backend.
 *
 * The interceptor itself is registered in `provideHttpClient(withInterceptors([…]))` — order matters,
 * so it is passed there rather than here. This provider only carries the things that have to exist
 * alongside it: the seeded database and the dev-time console handle.
 *
 * Delete this call, and the `mockApiInterceptor` entry in `provideHttpClient`, once the API is live.
 * Nothing in the entity services or the adapters is aware of the mock.
 *
 * @returns {EnvironmentProviders} The providers to spread into the app config.
 */
export function provideMockApi(): EnvironmentProviders {
    return makeEnvironmentProviders([
        provideEnvironmentInitializer(() => {
            // A handle on the seeded data from the browser console: `mockDb.units.query({ … })`,
            // `mockDb.properties.reset([…])` — handy while building screens against the mock.
            (globalThis as Record<string, unknown>)['mockDb'] = MOCK_DB;

            console.info(
                '[mock-api] serving %d properties, %d buildings, %d units, %d contacts, %d files, %d channels',
                MOCK_DB.dataset.properties.length,
                MOCK_DB.dataset.buildings.length,
                MOCK_DB.dataset.units.length,
                MOCK_DB.dataset.contacts.length,
                MOCK_DB.dataset.files.length,
                MOCK_DB.dataset.channels.length,
            );
        }),
    ]);
}
